(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["membership-plan-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__mpsInit) return;
  window.__mpsInit = true;

  /* -------- Helpers -------- */
  function getMpsRoot(el) {
    return el ? el.closest('.mps') : null;
  }

  function fireChange(root, value) {
    if (!root) return;
    root.dataset.selected = value;
    root.dispatchEvent(
      new CustomEvent('mps:change', {
        bubbles: true,
        detail: { value: value }
      })
    );
  }

  function revertToOnetime(root) {
    var once = root.querySelector('#mps-plan-once');
    if (once) once.checked = true;
    root.dataset.selected = 'onetime';
  }

  function revertToVip(root) {
    var vip = root.querySelector('#mps-plan-vip');
    if (vip) vip.checked = true;
    root.dataset.selected = 'vip';
  }

  /* -------- Change handler (UI-only, no AJAX) -------- */
  document.addEventListener('change', function (event) {
    var input = event.target.closest ? event.target.closest('.mps__input') : null;
    if (!input) return;

    var root = getMpsRoot(input);
    if (!root) return;

    fireChange(root, input.value);
  });

  /* -------- Hook into product-form "Add to Cart" --------
     When the user clicks Add to Cart and VIP is selected in the mps,
     we inject the VIP product into the request body so both products
     get added in one /cart/add call. This reuses the same multi-item
     pattern that ProductAdditionalService uses.
  */
  function patchProductFormSubmit() {
    var origFetch = window.fetch;
    if (!origFetch) return;

    window.fetch = function () {
      var url = arguments[0];
      var opts = arguments[1] || {};

      /* Only intercept /cart/add requests */
      var isCartAdd = typeof url === 'string' &&
        (url.indexOf('/cart/add') !== -1);

      if (!isCartAdd) return origFetch.apply(this, arguments);

      /* Find the active mps on the page */
      var mps = document.querySelector('.mps');
      if (!mps) return origFetch.apply(this, arguments);

      /* Skip if user is already a VIP member or chose one-time or VIP already in cart */
      if (mps.dataset.mpsIsVipMember === 'true') return origFetch.apply(this, arguments);
      if (mps.dataset.selected !== 'vip') return origFetch.apply(this, arguments);
      if (mps.dataset.mpsVipInCart === 'true') return origFetch.apply(this, arguments);

      var variantId = mps.getAttribute('data-mps-vip-variant');
      var sellingPlan = mps.getAttribute('data-mps-vip-selling-plan');
      if (!variantId) return origFetch.apply(this, arguments);

      var vipItem = { id: Number(variantId), quantity: 1 };
      if (sellingPlan) vipItem.selling_plan = Number(sellingPlan);

      /* Determine the body format and inject the VIP item */
      var body = opts.body;
      var newOpts = Object.assign({}, opts);

      if (body instanceof FormData) {
        /* product-form.js sends FormData for single-item adds.
           Convert to JSON multi-item format so we can add the VIP item. */
        var mainId = body.get('id');
        var mainQty = body.get('quantity') || '1';
        var sections = body.get('sections');
        var sectionsUrl = body.get('sections_url');

        /* Collect properties */
        var props = {};
        for (var pair of body.entries()) {
          if (pair[0].startsWith('properties[')) {
            var cleanKey = pair[0].replace(/^properties\[(.*?)\]$/, '$1');
            props[cleanKey] = pair[1];
          }
        }

        /* Collect selling_plan if present on the main form */
        var mainSellingPlan = body.get('selling_plan');

        var mainItem = {
          id: Number(mainId),
          quantity: Number(mainQty)
        };
        if (Object.keys(props).length > 0) mainItem.properties = props;
        if (mainSellingPlan) mainItem.selling_plan = Number(mainSellingPlan);

        var jsonBody = {
          items: [vipItem, mainItem]
        };

        if (sections) {
          jsonBody.sections = typeof sections === 'string' ? sections.split(',') : sections;
        }
        if (sectionsUrl) jsonBody.sections_url = sectionsUrl;

        newOpts.headers = Object.assign({}, opts.headers || {});
        newOpts.headers['Content-Type'] = 'application/json';
        newOpts.headers['Accept'] = 'application/json';
        delete newOpts.headers['X-Requested-With'];
        newOpts.body = JSON.stringify(jsonBody);

      } else if (typeof body === 'string') {
        /* Already JSON (from ProductAdditionalService path) — inject VIP item */
        try {
          var parsed = JSON.parse(body);
          if (parsed.items && Array.isArray(parsed.items)) {
            /* Check if VIP is not already in the items array */
            var alreadyHasVip = parsed.items.some(function (it) {
              return String(it.id) === String(variantId);
            });
            if (!alreadyHasVip) {
              parsed.items.unshift(vipItem);
              newOpts.body = JSON.stringify(parsed);
            }
          }
        } catch (e) {
          /* Can't parse — pass through unchanged */
        }
      }

      /* After the request succeeds, mark VIP as in-cart */
      return origFetch.call(this, url, newOpts).then(function (response) {
        /* Clone so we can read the body without consuming it for the caller */
        var cloned = response.clone();
        cloned.json().then(function (data) {
          if (!data || data.status) return; /* error response */
          mps.dataset.mpsVipInCart = 'true';
        }).catch(function () {});
        return response;
      });
    };
  }

  patchProductFormSubmit();

  /* -------- External cart sync: keep radio in sync with cart state -------- */
  function syncMpsFromCart() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cartData) {
        document.querySelectorAll('.mps').forEach(function (root) {
          var variantId = root.getAttribute('data-mps-vip-variant');
          if (!variantId) return;
          if (root.dataset.mpsIsVipMember === 'true') return;

          var found = false;
          if (cartData && cartData.items) {
            for (var i = 0; i < cartData.items.length; i++) {
              if (String(cartData.items[i].variant_id) === String(variantId)) {
                found = true;
                break;
              }
            }
          }

          root.dataset.mpsVipInCart = found ? 'true' : 'false';

          if (found && root.dataset.selected !== 'vip') {
            revertToVip(root);
          } else if (!found && root.dataset.selected === 'vip') {
            revertToOnetime(root);
          }
        });
      })
      .catch(function () {});
  }

  var syncTimer;
  function scheduleMpsSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncMpsFromCart, 350);
  }

  document.addEventListener('cart:updated', scheduleMpsSync);
  window.addEventListener('ct:floating-cart:updated', scheduleMpsSync);
})();
  } catch(e) { console.error(e); }
})();

})();
